import React from 'react';
import { fade, makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import MenuIcon from '@material-ui/icons/Menu';
import Button from '@material-ui/core/Button'
import {useHistory} from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    // display: 'none',
    fontWeight: 900,
    [theme.breakpoints.up('sm')]: {
      display: 'block',
      textAlign: 'center',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

export default function PrimarySearchAppBar() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [currentPage, setCurrentPage] = React.useState('home')

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);


  const handleMobileMenuClose = (event) => {
    const page = event.currentTarget.textContent
    setMobileMoreAnchorEl(null);
    handleNavigate(page)

  };

  let history = useHistory();

  function handleNavigate(page) {
    if (page === 'ABOUT US') {
      history.push('/about-us');
      setCurrentPage('about-us')
    }
    if (page === 'CHARITABLE CAUSES') {
      history.push('/charitable-causes');
      setCurrentPage('charitable-causes')
    }
    if (page === 'CONTACT') {
      history.push('/contact');
      setCurrentPage('contact')
    }
    if (page === 'PASTORAL TEAM') {
      history.push('/pastoral-team');
      setCurrentPage('pastoral-team')
    }
  }

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleMobileMenuClose}>
        PASTORAL TEAM
      </MenuItem>
      <MenuItem onClick={handleMobileMenuClose}>
        CHARITABLE CAUSES
      </MenuItem>
      <MenuItem onClick={handleMobileMenuClose}>
        ABOUT US
      </MenuItem>
      <MenuItem onClick={handleMobileMenuClose}>
       CONTACT
      </MenuItem>

    </Menu>
  );


  return (
    <div className={classes.grow}>
      <AppBar position="fixed"
              style={{
                background: 'whitesmoke',
                color: '#1f3769',
                boxShadow: 'rgba(187, 187, 187, 0.2) 0px 2px 4px -1px, rgba(189, 189, 189, 0.14) 0px 4px 5px 0px, rgba(96, 96, 96, 0.12) 0px 1px 10px 0px'
              }}>
        <Toolbar>
          <Typography onClick={() => history.push('/')}
                      style={{cursor: 'pointer', fontSize: '30px', fontFamily: 'Bree Serif'}}
                      className={classes.title}
                      variant="h6"
                      noWrap>
            Leeds BICC
          </Typography>
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            <Button
                onClick={handleMobileMenuClose}
                className={currentPage === 'pastoral-team'? 'active-menu': 'default-menu'}
            >
              PASTORAL TEAM
            </Button>
            <Button
                className={currentPage === 'charitable-causes'? 'active-menu': 'default-menu'}
                onClick={handleMobileMenuClose}>CHARITABLE CAUSES</Button>
            <Button
                className={currentPage === 'about-us'? 'active-menu': 'default-menu'}
                onClick={handleMobileMenuClose}>ABOUT US</Button>
            <Button
                className={currentPage === 'contact'? 'active-menu': 'default-menu'}
                onClick={handleMobileMenuClose}>CONTACT</Button>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </div>
  );
}
